"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgCursorPointer = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M12 4.667v-2m-5.252 4.08L5.333 5.334m1.415 12-1.415 1.415m12-12 1.415-1.415M4.667 12h-2m8.666-.667 5.482 17.038 3.852-3.852 4.815 4.814 3.851-3.851-4.814-4.815 3.852-3.852z" }))); };
exports.default = SvgCursorPointer;
//# sourceMappingURL=CursorPointer.js.map